import { lazy } from 'react';

import { formDrawerRegistry } from '@/app/surfaces/form-drawer-registry.js';

export const REGISTER_SERVICE_DRAWER_KEY = 'register-service';
export const REGISTER_PRODUCT_DRAWER_KEY = 'register-product';
export const EDIT_SERVICE_DRAWER_KEY = 'edit-service';
export const REGISTER_KIT_DRAWER_KEY = 'register-kit';

formDrawerRegistry[REGISTER_SERVICE_DRAWER_KEY] = {
  title: 'Novo serviço',
  size: 'md',
  component: lazy(async () => {
    const module = await import('@/features/catalog/surfaces/register-service.drawer.js');
    return { default: module.RegisterServiceDrawer };
  }),
};

formDrawerRegistry[REGISTER_PRODUCT_DRAWER_KEY] = {
  title: 'Novo produto',
  size: 'lg',
  component: lazy(async () => {
    const module = await import('@/features/catalog/surfaces/register-product.drawer.js');
    return { default: module.RegisterProductDrawer };
  }),
};

formDrawerRegistry[EDIT_SERVICE_DRAWER_KEY] = {
  title: 'Editar serviço',
  size: 'md',
  component: lazy(async () => {
    const module = await import('@/features/catalog/surfaces/service-edit.drawer.js');
    return { default: module.ServiceEditDrawer };
  }),
};

formDrawerRegistry[REGISTER_KIT_DRAWER_KEY] = {
  title: 'Novo kit',
  size: 'lg',
  component: lazy(async () => {
    const module = await import('@/features/catalog/surfaces/register-kit.drawer.js');
    return { default: module.RegisterKitDrawer };
  }),
};
